import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltInlineCommentsSectionFilterDropdownTriggerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-filter-dropdown-trigger-name-wireframe", __assign({}, transformedProps), children));
};
export default VeltInlineCommentsSectionFilterDropdownTriggerNameWireframe;
